import React from "react";
import { addMarkertoMap, addMarkertoMapNonCenter } from "utils/here-maps/newHereMapFunctions";
import { devLog } from "utils/devLog";
const DEMO_svgMarkup =
  '<svg width="30" height="30" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="10" stroke="black" stroke-width="2" fill="lightblue" /><circle cx="15" cy="15" r="3" stroke="black" stroke-width="2" fill="blue" /></svg>';
const destination_svgMarkup =
  '<svg width="30" height="30" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="10" stroke="black" stroke-width="2" fill="lightblue" /><circle cx="15" cy="15" r="3" stroke="black" stroke-width="2" fill="red" /></svg>';
var H = null;
var platform = null;
var map = null;

/**
 *
 * @param {
 * onMapCreated - imports the RFC token into the the project for use in the map
 * disablementCoords - imports the disablementCoords to generate that information
 * onUpdate - callbackfunc which gets the coords from the mainstate and
 *  rerenders the app as necessary based on those changes
 * } props
 * @returns
 */
export default class DisplayMapClass extends React.Component {
  //constructor and reference for the map component
  mapRef = React.createRef();
  constructor(props) {
    var tempCoords = {};
    if (props.disablementCoords.lat === undefined || props.disablementCoords.lat === null) {
      tempCoords = props.destinationCoords;
    } else {
      tempCoords = props.disablementCoords;
    }
    super(props);
    this.state = {
      map: null,
      disablementCoords: tempCoords,
      prevDisablementCoords: props.disablementCoords,
      destList: props.destList,
    };
  }

  //render the map
  componentDidMount() {
    //devLog("map pre render")
    H = window.H;
    platform = new H.service.Platform({
      apikey: "IkIwLN86NvpYn3Bw9vYEDaGeddpA0vjiYhL1VBKX3j8", //process.env.REACT_APP_HERE_JAVASCRIPT_MAP
    });

    const defaultLayers = platform.createDefaultLayers();
    //devLog("disablement coords", this.props.disablementCoords)
    map = new H.Map(this.mapRef.current, defaultLayers.vector.normal.map, {
      center: this.state.disablementCoords,
      zoom: this.props.zoomLevel || 15,
      pixelRatio: window.devicePixelRatio || 1,
      padding: { top: 80, left: 50, bottom: 60, right: 50 },
    });

    if (typeof this.props.onMapCreated === "function") {
      devLog("map created");
      this.props.onMapCreated({ H, map });
    } else {
      console.error("map not created");
    }

    // MapEvents enables the event system
    // Behavior implements default interactions for pan/zoom (also on mobile touch environments)
    // This variable is unused and is present for explanatory purposes

    // Create the default UI components to allow the user to interact with them
    // This variable is unused
    const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
    const ui = H.ui.UI.createDefault(map, defaultLayers);
    //devLog(behavior, ui)
    this.setState({ map, disablementCoords: this.props.disablementCoords });
    //loads objects if on selected Destinations

    //devLog("coords for initial map  generation", this.state.disablementCoords, this.props.disablementCoords)
    if (this.state.destList) {
      for (var i = 0; i < this.state.destList.length; i += 1) {
        devLog("adding dest List to map");
        addMarkertoMap({ H: H, hMap: map }, this.state.disablementCoords, DEMO_svgMarkup);
        addMarkertoMapNonCenter({ H: H, hMap: map }, this.state.destList[i].geometry.location, destination_svgMarkup);
      }
    }

    //loads objects on provider enroute and selecting provider
    else if (!this.props.onUpdate) {
      devLog("adding marker to map on provider enroute");
      addMarkertoMap({ H: H, hMap: map }, this.state.disablementCoords, DEMO_svgMarkup);
    }

    //loads objects on LocateUser
    else {
      devLog("add click marker map");
      addMarkertoMap({ H: H, hMap: map }, this.state.disablementCoords, DEMO_svgMarkup);
      this.setUpClickListener(H, map, this.secondCallBack);
    }
  }

  componentWillUnmount() {
    this.state.map.dispose();
  }

  //click listener that allows the map to change on click
  setUpClickListener = (H, hMap, callBack) => {
    //if()
    var coord = {};
    hMap.addEventListener("tap", (evt) => {
      coord = hMap.screenToGeo(evt.currentPointer.viewportX, evt.currentPointer.viewportY);
      callBack(H, hMap, coord);
    });
    if (Object.keys(coord).length === 0) {
      return;
    }
    //callBack(map, coord)
  };

  //second callback which is a callback functionto run the add marker to map (will be deprocated)
  secondCallBack = (H, hMap, coord) => {
    devLog("updating marker on click");
    this.NewAddMarkerToMap(H, hMap, coord, DEMO_svgMarkup);
  };

  //function that adds a simple marker to the map
  NewAddMarkerToMap = (H, hMap, coords, markUp) => {
    //var map = window.map
    if (hMap.getObjects().length <= 0) {
      //do nothing
    } else {
      window.mapMarkers = [];
      hMap.removeObjects(hMap.getObjects());
    }
    var icon2 = new H.map.Icon(markUp);
    const marker = new H.map.Marker(coords, { icon: icon2 });
    hMap.addObject(marker);
    hMap.setCenter(coords);
    this.setState({
      disablementCoords: this.props.disablementCoords,
      prevDisablementCoords: this.state.disablementCoords,
    });
    this.props.onUpdate(coords);
  };

  render() {
    return (
      <React.Fragment>
        <div ref={this.mapRef} style={{ height: this.props.height }} />
      </React.Fragment>
    );
  }
}
